import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from './core/guards/auth.guard';
import { LayoutComponent } from './layouts/layout.component';
import { ShowPrivacyComponent } from './terms/show-privacy/show-privacy.component';
import { ShowTermsComponent } from './terms/show-terms/show-terms.component';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'account',
    loadChildren: () => import('./account/account.module').then(m => m.AccountModule),
  },
  // tslint:disable-next-line: max-line-length
  {
    path: 'service',
    component: ShowTermsComponent,
    loadChildren: () => import('../app/terms/terms.module').then(m => m.TermsModule),
  },
  {
    path: 'privacy',
    component: ShowPrivacyComponent,
    loadChildren: () => import('../app/terms/terms.module').then(m => m.TermsModule),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
